export const RollCallDailyAttedanceReport = [
    {
      "s_no": 1,
      "BioMetricId": 1,
      "Employee": "Baji",
      "Designation": "General",
      "Dept": "General",
      "ActualShift": "General Shift",
      "Date": "25/03/2025",
      "Status": "Missed Swipe",
      "InTime": "10:04:55",
      "OutTime": "",
      "Duration": "00:00"
    },
    {
      "s_no": 2,
      "BioMetricId": 2,
      "Employee": "ali",
      "Designation": "General",
      "Dept": "General",
      "ActualShift": "General Shift",
      "Date": "25/03/2025",
      "Status": "Missed Swipe",
      "InTime": "10:24:33",
      "OutTime": "",
      "Duration": "00:00"
    },
    {
      "s_no": 3,
      "BioMetricId": 3,
      "Employee": "rajesh",
      "Designation": "General",
      "Dept": "General",
      "ActualShift": "General Shift",
      "Date": "25/03/2025",
      "Status": "Missed Swipe",
      "InTime": "10:48:22",
      "OutTime": "",
      "Duration": "00:00"
    },
    {
      "s_no": 4,
      "BioMetricId": 4,
      "Employee": "Babji",
      "Designation": "General",
      "Dept": "General",
      "ActualShift": "General Shift",
      "Date": "25/03/2025",
      "Status": "Missed Swipe",
      "InTime": "09:59:14",
      "OutTime": "",
      "Duration": "00:00"
    },
    {
      "s_no": 5,
      "BioMetricId": 5,
      "Employee": "Chandu",
      "Designation": "General",
      "Dept": "General",
      "ActualShift": "General Shift",
      "Date": "25/03/2025",
      "Status": "Missed Swipe",
      "InTime": "10:11:28",
      "OutTime": "",
      "Duration": "00:00"
    },
    {
      "s_no": 6,
      "BioMetricId": 6,
      "Employee": "Das",
      "Designation": "General",
      "Dept": "General",
      "ActualShift": "General Shift",
      "Date": "25/03/2025",
      "Status": "Missed Swipe",
      "InTime": "10:04:52",
      "OutTime": "",
      "Duration": "00:00"
    }
  ]
  